import PropTypes from 'prop-types';
import React from 'react';
import Select from 'components/StyledSelect/react_select';
import { request } from '../../../services';
import qs from 'qs';
import { debounce, omit, isArray } from 'lodash';
import UserType from 'types/user';
import MediaQuery from 'react-responsive';
import { CUT_POINT } from 'config/constants';

class UserSearch extends React.Component {
  state = { options: [], isLoading: false };

  componentWillMount = () => (Object.keys(this.props.initialValues).length > 0 ?
    this.loadInitialValues() : null);

  onChange = (value) => {
    const options = value ? this.state.options : [];
    this.setState({ value, options });
    if (this.props.onChange) this.props.onChange(value);
  }

  loadInitialValues = () => {
    if (isArray(this.props.initialValues)) {
      this.setInitialState(this.props.initialValues);
    } else {
      const filters = qs.stringify(this.props.initialValues);
      request(`users?${filters}`)
        .then(({ json }) => this.setInitialState(json.users));
    }
  }

  setInitialState = (users) => {
    let value = this.buildOptions(users);
    if (!this.props.multi) value = value[0];
    this.setState({ value });
  }

  searchUsers = debounce((value) => {
    if (value.length <= 2) return;
    const { employableType } = this.props;
    this.setState({ isLoading: true });
    const queryObject = { query: value };
    if (employableType) {
      queryObject.employable_type = employableType;
    }
    const queryString = qs.stringify(queryObject, { arrayFormat: 'brackets' });
    request(`users?${queryString}`)
      .then(({ json }) => this.handleSearchResults(json.users))
      .catch(error => this.handleSearchError(error));
  }, 300);

  handleSearchResults = (users) => {
    const { employableType } = this.props;
    const filteredUsers = employableType && employableType.length > 0
      ? users.filter(user => employableType.includes(user.employable_type))
      : users;
    this.setState({
      isLoading: false,
      options: this.buildOptions(filteredUsers),
    });
  }

  handleSearchError = () => this.setState({ isLoading: false, options: [] });

  buildOptions = users => users.map(user => ({
    ...user,
    value: `${user.name} - ${user.employable_type}`,
    label: `${user.name} - ${user.employable_type}`,
  }));

  render = () => {
    const { value, options, isLoading } = this.state;
    const { defaultOptions, placeholder } = this.props;
    const otherProps = omit(this.props, ['employableType', 'value']);
    return (<MediaQuery minWidth={CUT_POINT}>
      {matches => (matches ? (<Select
        {...otherProps}
        autoSize={false}
        options={defaultOptions.concat(options)}
        value={value}
        onInputChange={this.searchUsers}
        matchProp="label"
        placeholder={placeholder}
        noResultsText="Type to search"
        clearable
        onChange={this.onChange}
        isLoading={isLoading}
      />) : (<Select
        {...otherProps}
        options={defaultOptions.concat(options)}
        value={value}
        onInputChange={this.searchUsers}
        matchProp="label"
        placeholder={placeholder}
        noResultsText="Type to search"
        clearable
        onChange={this.onChange}
        isLoading={isLoading}
      />))
      }
    </MediaQuery>);
  }
}

UserSearch.defaultProps = {
  defaultOptions: [],
  multi: false,
  initialValues: {},
  isAssigneeSelect: false,
};

UserSearch.propTypes = {
  employableType: PropTypes.arrayOf(
    PropTypes.oneOf(['Employee', 'Estimator', 'Installer', 'IQM']),
  ),
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  defaultOptions: PropTypes.array,
  initialValues: PropTypes.oneOfType([
    PropTypes.shape({
      estimator: PropTypes.arrayOf(PropTypes.number),
      employee: PropTypes.arrayOf(PropTypes.number),
      installer: PropTypes.arrayOf(PropTypes.number),
      iqm: PropTypes.arrayOf(PropTypes.number),
    }),
    PropTypes.arrayOf(UserType),
  ]),
  multi: PropTypes.bool.isRequired,
};

export default UserSearch;



// WEBPACK FOOTER //
// ./client/app/shared/components/UserSearch/index.jsx